import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const PaperIcon = ({ color = 'currentColor', width = 41, height = 40, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="8.75" y="6.75" width="23.5" height="26.5" stroke={color} strokeWidth="1.5" />
            <rect x="15.4004" y="14.9004" width="11" height="1.4" fill={color} />
            <rect x="15.4004" y="19.3003" width="11" height="1.4" fill={color} />
            <rect x="15.4004" y="23.7002" width="11" height="1.4" fill={color} />
        </svg>
    );
};
